import React from 'react';
import { styled } from '@mui/system';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Link } from "react-router-dom";

const Title = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.title,
    fontSize: 16,
    fontWeight: 700,
}));

const Description = styled(DialogContentText)(({ theme }) => ({
    color: theme.palette.text.main.normal,
    textAlign: 'justify',
    fontSize: 13,
    fontWeight: 700,
    marginBottom: 0,
}));

const Label = styled('span')({
    fontSize: 13,
    display: "inline",
    textTransform: 'none',
});

const StyledButton = styled(Button)(({ theme }) => ({
    minWidth: 0,
    marginRight: 15,
    fontSize: 14,
    fontWeight: 700,
    padding: '3px 12px 3px 12px',
    color: theme.palette.text.title,
}));

const ConfirmButton = styled(StyledButton)(({ theme }) => ({
    backgroundColor: theme.palette.background.lighter,
    "&:hover": {
        opacity: 0.8,
    },
}));

const RejectButton = styled(StyledButton)(({ theme }) => ({
    borderColor: "#fff",
    "&:hover": {
        backgroundColor: 'transparent',
    },
    padding: 10,
    paddingRight: 0,
}));

function ExitWarning(props) {
    const { open } = props;
    const { confirmHandler, rejectHandler } = props;

    return (
        <Dialog open={open} fullWidth maxWidth={"xs"}>
            <DialogTitle style={{ paddingBottom: 5 }}>
                <Title>Are you sure?</Title>
            </DialogTitle>
            <DialogContent>
                <Description>You will lose all your current progress, including records of any previous TIPars submissions (make sure to make a copy of the submission IDs if you want to keep them). Are you sure you want to continue?<br /><br />
                Pressing "Yes" will bring you back to <Link style={{ textDecoration: 'underline' }} to={`/tryNow`}>TRY NOW</Link>. Alternatively, press <Link style={{ textDecoration: 'underline' }} to={`/`}>here</Link> to go to the home page.
                </Description>
            </DialogContent>
            <DialogActions>
                <RejectButton disableRipple onClick={rejectHandler}>
                    <Label>No</Label>
                </RejectButton>
                <ConfirmButton disableRipple onClick={confirmHandler}>
                    <Label>Yes</Label>
                </ConfirmButton>
            </DialogActions>
        </Dialog>
    )
}

export default ExitWarning;